/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { useEffect } from "react";
import { API, CONFIGUREROUTES } from "../../../globals/globals";
import { useGetRn620sQuery } from "../../../store/api/deviceConfig/deviceConfigApiSlice";
import { Rn620sColumns } from "../../../components/Shared/Table/Columns";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { paginationModelSelector } from "../../../store/helpers/helperSelectors";
import { setConfigCounts } from "../../../store/api/deviceConfig/reducers";
import { useStoreDispatch } from "../../../store/hooks";
import { initialState } from "../../../store/helpers/helperInitialState";

export const useRn620sData = () => {
  const location = useLocation();
  const dispatch = useStoreDispatch();
  const locationPath = location?.pathname.split("/");
  const { rn620 = initialState.pagination } = useSelector(paginationModelSelector);

  const args = {
    filters: `page=${rn620.page.toString()}&size=${rn620.pageSize.toString()}`,
    deviceKey: locationPath[2],
  };
  const { data, isLoading, refetch } = useGetRn620sQuery(args, {
    pollingInterval: API.ENDPOINTS.RN620S.pollingInterval || API.POLLING_INTERVAL,
  });

  useEffect(() => {
    if (!!data?.data) {
      dispatch(setConfigCounts({ [CONFIGUREROUTES.RN620.Path]: data?.totalItems || 0 }));
    }
  }, [data?.data, data?.totalItems, dispatch]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data,
    isLoading,
    Rn620sColumns,
  };
};
